export default __webpack_public_path__ + "static/media/slide20.018df1fc.jpg";